// Add your custom JS here.
import $ from 'jquery';
import contentFilter from './bc-content-filter';
import exhibitorList from './page-specific/exhibitor-list';
import flexDetect from './utility/flex-detect';
import nav from './navigation';
import niftyTables from './nifty-tables';
import seniorExpoBooths from './page-specific/senior-expo-booths';

var dataTable = $('.nifty-table');
var filterContent = $('.bc-filter-content');
var floorplan = $('.floorplan');

//Global imports -- always import
exhibitorList.init();
flexDetect.init();
nav.init();
seniorExpoBooths.init();

// Conditional imports -- only run this JS if certain elements exist on page
if (dataTable.length > 0) {
    niftyTables.init();
}

if (filterContent.length > 0) {
    contentFilter.init();
}

if (floorplan.length > 0) {
    seniorExpoBooths.init();
}